<template>
  <div class="link-wrapper">
    <router-link :to="{ name: 'CallsRecords' }">
      Records
    </router-link>
    <router-link :to="{ name: 'CallsLogs' }">
      Logs
    </router-link>
    <router-link
      v-if="computedIsAdmin"
      :to="{ name: 'CallsIssues' }">
      Issues
    </router-link>
    <router-link :to="{ name: 'CallsReport' }">
      Issues Report
    </router-link>
    <router-link
      v-if="computedIsAdmin"
      :to="{ name: 'AutoCalls' }">
      Auto-Calls
    </router-link>
    <router-link
      v-if="computedIsAdmin"
      :to="{ name: 'AutoCallsReport' }">
      Auto-Calls Report
    </router-link>
    <router-link
      v-if="computedIsAdmin"
      :to="{ name: 'CallsGiftsReport' }">
      Gifts Report
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CallsLink',
  components: {

  },
  data () {
    return {};
  },
  computed: {
    ...mapGetters({
      computedIsAdmin: 'auth/isAdmin'
    })
  }

};
</script>
